import { Component, OnInit } from '@angular/core';
import { TiposerviciosDocumentosService } from '../../../../shared/services/tiposerviciosdocumento.service';
import { ActivatedRoute } from '@angular/router';
import { HttpEventType } from '@angular/common/http';
import { DigitalesService } from '../../../../shared/services/digitales.service';
import { Administracion } from '../../../../shared/model/administracion.model';
import { AdministracionService } from '../../../../shared/services/administracion.services';
import { gpcGoogleService } from '../../../../shared/services/gpcGoogle.service';


@Component({
  selector: 'app-digitales',
  templateUrl: './digitales.component.html',
  styleUrls: ['./digitales.component.scss']
})


export class DigitalesComponent implements OnInit {

archivos: any[] = [];
  imagenGrande: string | null = null;
  zoom: number = 1;
  placa: string | null = null;
  administraciones: Administracion[] = [];
  private soportesExistentesCargados = false;
  cargandoSoportesExistentes = false;
  soportesListos = false;
  constructor( private tiposerviciodocumentoService: TiposerviciosDocumentosService, 
    private route: ActivatedRoute,
    private digitalesService: DigitalesService,
    private administracionesServices: AdministracionService,
    private gpcGoogleService: gpcGoogleService){

  }
ngOnInit(): void {
  this.archivos = [];
  this.soportesListos = false;
  this.route.paramMap.subscribe(params => {
    this.placa = params.get('placa');
    const idServicesStr = params.get('servicio');
    this.cargarDataAdmin();
    if (this.placa && idServicesStr) {
      const idServices = Number(idServicesStr);

      if (!isNaN(idServices)) {
        this.ValidarDocumentos(idServices);
      } else {
        console.error('El parámetro "servicio" no es un número válido:', idServicesStr);
      }

    } else {
      console.error('Parámetros inválidos recibidos. Placa:',this.placa, 'Servicio:', idServicesStr);
    }
  });
}

 isImage(file: File): boolean {
  const imageTypes = ['image/jpeg', 'image/png', 'image/jpg'];
  return imageTypes.includes(file.type);
}

  getQuantidadSoportesCargados(): number {
    return this.archivos.filter(a => a.soporteExistente || a.file).length;
  }

  getPorcentajeSoportes(): number {
    if (this.archivos.length === 0) return 0;
    const cargados = this.getQuantidadSoportesCargados();
    return Math.round((cargados / this.archivos.length) * 100);
  }

 private cargarDataAdmin():void{
  this.administracionesServices.obtenerTodas().subscribe({
      next: (data) => {
        console.log(data);
        this.administraciones = data;
        this.intentarCargarSoportesExistentes();
        
      },
      error: (err) => {
        console.error("Error al cargar los conductores:", err);
        this.soportesListos = true;
      },
    });
 }

ValidarDocumentos(idServices: number) {
  this.tiposerviciodocumentoService
    .getTiposervicioDocumentoById(idServices)
    .subscribe(
      (servicio) => {
   //     console.log(servicio);

        // Construcción dinámica del array `archivos`
        this.archivos = servicio.map((item: any) => {
          return {
            id: item.documento?.id ?? null,
            nombre: item.documento?.tipoDocumento ?? '',
            file: null,
            prefijo: item.documento?.sigla ?? '',
            formatos: item.documento?.formatos.split(",").map((formato: string) => formato.trim()) ?? [],
            acceptedFormats: item.documento?.formatos.split(",").map((formato: string) => formato.trim()) ?? [],
            estado : null,
            mensaje:'',
            progreso:0,
            soporteExistente: null,
            archivoActual: false,
            verificandoSoporte: false
          };
        });
        console.log(this.archivos);
        this.intentarCargarSoportesExistentes();
      },
      (error) => {
        console.error("Error obteniendo el servicio:", error);
        this.soportesListos = true;
      }
    );
}


onFileChange(event: any, archivoId: number) {
    const file: File = event.target.files[0];
    if (!file) return;

    const archivoIndex = this.archivos.findIndex(a => a.id === archivoId);
    if (archivoIndex === -1) return;

    const archivo = this.archivos[archivoIndex];
    const extension = file.name.split('.').pop()?.toLowerCase();
    if (archivo && (!extension || !archivo.acceptedFormats.includes(extension))) {
      archivo.mensaje = `Formato no permitido. Solo se aceptan: ${archivo.acceptedFormats.join(', ')}`;
      archivo.estado = 'error';
      archivo.file = null;
      archivo.progreso = 0;
      return;
    }

    const reader = new FileReader();
    reader.onload = (e: any) => {
      archivo.file = {
        file,
        preview: e.target.result
      };
      archivo.estado = null;
      archivo.mensaje = '';
      archivo.progreso = 0;
      archivo.archivoActual = true;
    };
    reader.readAsDataURL(file);
  }

// Cambiar estilo al arrastrar el archivo
onDragOver(event: DragEvent) {
  event.preventDefault(); // necesario para permitir drop
  const target = event.currentTarget as HTMLElement;
  target.classList.add('drag-over');
}

onDragLeave(event: DragEvent) {
  event.preventDefault();
  const target = event.currentTarget as HTMLElement;
  target.classList.remove('drag-over');
}



  removeFile(id: number) {
    const archivo = this.archivos.find(a => a.id === id);
    if (archivo) {
      archivo.file = null;
      archivo.estado = null;
      archivo.progreso = 0;
      archivo.mensaje = '';
      archivo.archivoActual = false;
    }
  }

onDrop(event: DragEvent, id: number) {
  event.preventDefault();
  const target = event.currentTarget as HTMLElement;
  target.classList.remove('drag-over');

  if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
    const file = event.dataTransfer.files[0];
    const archivo = this.archivos.find(a => a.id === id);
    const extension = file.name.split('.').pop()?.toLowerCase();
    if (archivo && (!extension || !archivo.acceptedFormats.includes(extension))) {
      archivo.mensaje = `Formato no permitido. Solo se aceptan: ${archivo.acceptedFormats.join(', ')}`;
      archivo.estado = 'error';
      archivo.file = null;
      archivo.progreso = 0;
      return;
    }

    const reader = new FileReader();
    reader.onload = (e: any) => {
      if (archivo) {
        archivo.file = { file, preview: e.target.result };
        archivo.estado = null;
        archivo.mensaje = '';
        archivo.progreso = 0;
        archivo.archivoActual = true;
      }
    };
    reader.readAsDataURL(file);
    event.dataTransfer.clearData();
  }
}

  verImagenCompleta(preview: string) {
    this.imagenGrande = preview;
    this.zoom = 1;
  }

  verSoporteExistente(archivo: any): void {
    const soporte = archivo?.soporteExistente;
    if (!soporte?.url) {
      return;
    }

    if (soporte.isImage) {
      this.verImagenCompleta(soporte.url);
      return;
    }

    window.open(soporte.url, '_blank');
  }

  cerrarImagenCompleta() {
    this.imagenGrande = null;
  }

  hacerZoom(event: WheelEvent) {
    event.preventDefault();
    this.zoom += event.deltaY * -0.01;
    this.zoom = Math.min(Math.max(1, this.zoom), 3);
    const img = event.target as HTMLImageElement;
    img.style.transform = `scale(${this.zoom})`;
  }

  reemplazarSoporte(archivoId: number): void {
    const fileInput = document.getElementById('fileInput' + archivoId) as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }
 

subirArchivo(id: number, nombreCarpeta: string,prefijo:string) {
  const archivo = this.archivos.find(a => a.id === id);
  if (!archivo || !archivo.file) return;

  archivo.estado = 'subiendo';
  archivo.progreso = 0;
  nombreCarpeta = this.administraciones[0].nit+"/"+nombreCarpeta +"/"+this.placa;
  console.log("Subiendo archivo:", archivo.file.file.name, "a la carpeta:", nombreCarpeta, "con prefijo:", prefijo);
  console.log("Archivo a subir:", archivo.file.file);
   console.log("PLACA",this.placa);
  this.digitalesService.subirArchivoVehiculos(archivo.file.file, id, nombreCarpeta, this.placa!,prefijo)

  
    .pipe(
      
      // Cambia la llamada para que retorne eventos (HttpEvent)
      // Esto requiere que el servicio 'subirArchivo' use { reportProgress: true, observe: 'events' }
    )
    .subscribe({
      next: (event) => {
       // console.log(event);
        if (event.type === HttpEventType.UploadProgress && event.total) {
          archivo.progreso = Math.round(100 * event.loaded / event.total);
        } else if (event.type === HttpEventType.Response) {
          archivo.estado = 'exito';
          archivo.mensaje = `Archivo ${id} subido con éxito`;
          archivo.archivoActual = false;
          archivo.soporteExistente = this.construirSoporteActual(archivo);
        }
      },
      error: (error) => {
        archivo.estado = 'error';
        archivo.mensaje = `Error al subir el archivo ${id}`;
        console.error(archivo.mensaje, error);
      }
    });
}

      private intentarCargarSoportesExistentes(): void {
        if (this.soportesExistentesCargados || !this.placa || !this.archivos.length || !this.administraciones.length) {
          return;
        }

        this.soportesExistentesCargados = true;
        this.cargarSoportesExistentes();
      }

      private async cargarSoportesExistentes(): Promise<void> {
        const nit = this.administraciones?.[0]?.nit;
        if (!nit || !this.placa) {
          this.soportesExistentesCargados = false;
          return;
        }

        this.cargandoSoportesExistentes = true;
        this.soportesListos = false;
        try {
          for (const archivo of this.archivos) {
            archivo.verificandoSoporte = true;
            const basePath = `${nit}/vehiculos/${this.placa}/${archivo.prefijo}_${this.placa}`;
            const extensiones = this.normalizarExtensiones(archivo.acceptedFormats);
            const extension = await this.detectarExtensionSoporte(basePath, extensiones);

            if (!extension) {
              archivo.verificandoSoporte = false;
              continue;
            }

            try {
              const signed = await this.gpcGoogleService.getSignedUrl(`${basePath}.${extension}`).toPromise();
              if (signed?.url) {
                archivo.soporteExistente = {
                  url: signed.url,
                  extension,
                  isImage: this.esExtensionImagen(extension),
                  name: `${archivo.prefijo}_${this.placa}.${extension}`
                };
              }
            } catch {
              // Ignorar si no existe.
            } finally {
              archivo.verificandoSoporte = false;
            }
          }
        } finally {
          this.cargandoSoportesExistentes = false;
          this.soportesListos = true;
        }
      }

      private async detectarExtensionSoporte(basePath: string, extensiones: string[]): Promise<string | null> {
        for (const ext of extensiones) {
          try {
            const res = await this.gpcGoogleService.getSignedUrl(`${basePath}.${ext}`).toPromise();
            if (res?.url) {
              return ext;
            }
          } catch {
            // continuar
          }
        }
        return null;
      }

      private normalizarExtensiones(extensiones: string[] = []): string[] {
        const valores = extensiones
          .map((ext) => String(ext).replace('.', '').trim().toLowerCase())
          .filter(Boolean);

        return valores.length ? valores : ['jpg', 'jpeg', 'png', 'pdf'];
      }

      private esExtensionImagen(extension: string): boolean {
        return ['jpg', 'jpeg', 'png', 'webp'].includes(extension.toLowerCase());
      }

      private construirSoporteActual(archivo: any): any {
        if (!archivo?.file?.preview || !archivo?.file?.file) {
          return archivo?.soporteExistente ?? null;
        }

        const file = archivo.file.file as File;
        const extension = file.name.split('.').pop()?.toLowerCase() ?? '';

        return {
          url: archivo.file.preview,
          extension,
          isImage: this.isImage(file),
          name: file.name
        };
      }
}







interface ArchivoConPreview {
  file: File;
  preview: string;
}